// extracted by mini-css-extract-plugin
export var Alert = "Alert-module--Alert--y99Nz";
export var DismissButton = "Alert-module--DismissButton--30Lx5";
export var neutral = "Alert-module--neutral--1gfz8";
export var error = "Alert-module--error--3O2z1";
export var warning = "Alert-module--warning--2q9ME";
export var success = "Alert-module--success--3RDBt";
export var divider = "Alert-module--divider--3gGsx";
export var iconAndTextWrapper = "Alert-module--iconAndTextWrapper--22Kgv";
export var iconColumn = "Alert-module--iconColumn--1oVxM";